// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__atPyf","buttons":"RemoveExpirationActionButtons_buttons__1gOo1"};